import { IconProps } from "./types";

export function IconAdd({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        fill={"none"}
        stroke={"currentColor"}
        d="M12 5v14m-7-7h14"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}
